import React from 'react';
import { Check } from 'lucide-react';
import { getQuestion } from './scoring';
import { useScore } from './ScoreContext';
interface ReaderPathCheckProps {
  questionId: string;
  checkLabel?: string;
  confirmationText?: string;
  /** Compact layout for the single v2 Quick Check (2×2 desktop grid, tighter outer spacing). */
  compact?: boolean;
}
export function ReaderPathCheck({
  questionId,
  checkLabel = 'Quick Check',
  confirmationText = 'Saved. This is part of your score.',
  compact = false
}: ReaderPathCheckProps) {
  const {
    answers,
    setAnswer
  } = useScore();
  const question = getQuestion(questionId);
  if (!question) return null;
  const selectedScore = answers[questionId];
  return <div className={`relative w-full overflow-hidden rounded-3xl border border-gray-200/70 bg-paper-dark shadow-[inset_0_2px_16px_rgba(26,40,56,0.05)] ${compact ? 'my-0 p-5 sm:p-6 md:p-7' : 'my-16 p-6 sm:p-8 md:p-12'}`} data-id="element-444" data-mp="nayig7nipaan">
      <div className={`absolute left-0 w-1 rounded-r-full bg-seaglass md:w-1.5 ${compact ? 'bottom-4 top-4' : 'bottom-6 top-6'}`} data-id="element-445" data-mp="e9qv2kmjhtvc" />
      <div className={compact ? 'pl-4 md:pl-5' : 'pl-4 md:pl-6'} data-id="element-446" data-mp="2h8aq0n26au2e">
        <div className={`flex items-center gap-2.5 ${compact ? 'mb-3.5' : 'mb-5'}`} data-id="element-447" data-mp="2m2exd7fcp440">
          <div className="h-2 w-2 rounded-full bg-seaglass" data-id="element-448" data-mp="27d91ntfq1w0v" />
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-seaglass" data-id="element-449" data-mp="2carcxqh7onc1">
            {checkLabel}
          </span>
        </div>

        <h3 className={`max-w-2xl font-serif leading-snug text-navy ${compact ? 'mb-5 text-2xl md:mb-6 md:text-[1.85rem]' : 'mb-8 text-2xl md:mb-10 md:text-[2rem]'}`} data-id="element-450" data-mp="3014uuo6315sw">
          {question.prompt}
        </h3>

        <div className={compact ? 'grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-3.5' : 'flex flex-col gap-3'} data-id="element-451" data-mp="2qznklmfcvyc4">
          {question.options.map(option => {
          const isSelected = selectedScore === option.score;
          return <button key={option.letter} type="button" onClick={() => setAnswer(questionId, option.score)} aria-pressed={isSelected} className={`flex min-h-[64px] w-full items-start gap-4 rounded-2xl border p-5 text-left transition-all duration-200 ${compact ? 'md:gap-4 md:p-5' : 'md:gap-5 md:p-6'} ${isSelected ? 'border-seaglass bg-seaglass/10 ring-1 ring-seaglass/40' : 'border-gray-200 bg-white hover:border-seaglass/50'}`} data-id="element-452" data-mp="1jmdexaq4hr0h">
                <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border md:h-7 md:w-7 ${isSelected ? 'border-seaglass bg-seaglass text-white' : 'border-gray-300 bg-white text-transparent'}`} data-id="element-453" data-mp="37kwbsa6pb556">
                  <Check className="h-3.5 w-3.5" strokeWidth={3} data-id="element-454" data-mp="2yhv78dxhhm3m" />
                </span>
                <span className="flex-1 leading-relaxed text-text" data-id="element-455" data-mp="2tl4qrphrooho">
                  <strong className="mr-2.5 font-serif text-lg font-semibold text-navy" data-id="element-456" data-mp="2ols1yz7c57cg">
                    {option.letter}.
                  </strong>
                  {option.text}
                </span>
              </button>;
        })}
        </div>

        {selectedScore !== undefined && <div className={`flex items-center gap-2.5 text-base font-medium text-seaglass ${compact ? 'mt-4' : 'mt-6'}`} data-id="element-457" data-mp="vb5w9vtuke02">
            <Check className="h-4 w-4" strokeWidth={2.5} data-id="element-458" data-mp="zbprgtuv17jk" />
            <span data-id="element-459" data-mp="za4znbzxk2pe">{confirmationText}</span>
          </div>}
      </div>
    </div>;
}